module.exports = __webpack_public_path__ + "static/img/solution_train.4036d140.png";